export default "__VITE_ASSET__BJEuwRGi__"